/** The VFX glyph atlas cannot be built (no 2D canvas context). Effects cannot be drawn: fail loudly. */
export class VfxAssetError extends Error {
  override readonly name = 'VfxAssetError'
}
